import * as React from 'react';
import DocumentsService from '../../shared/services/DocumentsService';
import InboundService from '../../shared/services/InboundService';
import ContainersService from '../../shared/services/ContainersService';
import UserService from '../../shared/services/UserService';
import WarehouseService from '../../shared/services/WarehouseService';
import PackingListService from '../../shared/services/PackingListService';

export interface ShipperInboundContextValues {
  inboundService: InboundService;
  packingListService: PackingListService;
  documentsService: DocumentsService;
  containersService: ContainersService;
  userService: UserService;
  warehouseService: WarehouseService;
}

const defaultValues: ShipperInboundContextValues = {
  inboundService: null,
  packingListService: null,
  documentsService: null,
  containersService: null,
  userService: null,
  warehouseService: null
};

const ShipperInboundContext = React.createContext(defaultValues);

export default ShipperInboundContext;
